<nb-card status="primary" size="large">
  <nb-card-header>Help</nb-card-header>

  <nb-card-body>
    <h1>Dashclicker</h1>
    <p>
      Dashclicker is an open-source free-to-play incremental clicker game. This
      is the second iteration of the game, rewritten from scratch in Angular.
      Initial version of the game is still available for play at
      <a href="http://old.dashclicker.com" target="_blank"
        >old.dashclicker.com</a
      >.
    </p>

    <h4>Frequently asked questions</h4>
    <div>
      <h6>How do I play?</h6>
      <p>
        While there is no one <em>correct</em> way of playing as playstyles
        differ, my own preferred approach goes like this:
      </p>

      <ol>
        <li>
          Buy all the click upgrades, making auto clickers a priority since they
          unlock new tasks.
        </li>
        <li>
          Complete tasks that reset click upgrade costs, one by one (e.g,
          complete a task, then buy upgrades, then complete the next task and
          buy upgrades again).
        </li>
        <li>
          When click upgrades are maxed, do the same for analytics generators.
        </li>
        <li>
          When generators are maxed, go through projects and complete them,
          upgrading generators after completing projects marked in green.
        </li>
        <li>
          Finally, when all the next upgrades and projects seem too difficult to
          achieve (for example, if I'm generating 1M/s but the next upgrade
          costs 100t), I make a few trades in the market for every analytics
          resource, build up clicks and start a new run from the wallet.
        </li>
      </ol>
      <h6>I am stuck, next upgrades are unreachable</h6>

      <p>
        If you can't reach a task milestone, try stocking up on clicks &
        analytics and using the "New run" button you'll find in your wallet. Due
        to the way of how costs and prices are calculated, this is the actual
        way of how to progress in the game (<em>prestige mechanic</em>). While
        tasks reset costs, calculations for the next upgrade costs take into
        account your already owned number of upgrades, thus you should upgrade
        as far as possible before using resets from tasks.
      </p>

      <h6>How long does it take to complete the game?</h6>
      <p>
        It should take you around 2-4 hours to complete the game (all tasks
        finished, level #50 reached), but as new features are added, the play
        time might increase considerably.
      </p>

      <h6>There is too much clicking, there is no <em>buy max</em> button</h6>
      <p>
        If you are playing on a computer, you can click on a button and hold
        Enter key to trigger the action repeatedly. You can also navigate
        between buttons by pressing Tab (forwards) or Shift-Tab (backwards).
      </p>

      <h6>I refreshed the game and found my wallet empty</h6>

      <p>
        Most likely you didn't deposit your assets before exiting the game,
        which can be considered a <em>hard reset</em> of the game. Since
        December 18th, 2022 all data is stored locally on your device, so you
        can always play around with Local Storage and set the values manually.
      </p>
    </div>

    <h4>About the developer</h4>
    <p>
      My name is Armands and I am a front-end web developer from Riga, Latvia. I
      really enjoy incremental games and love to code, so that is how this
      project came to be. If you enjoyed the game and want to support its
      continued development, you can:
    </p>
    <p>
      <a href="https://ko-fi.com/armands" target="_blank" class="kofi">
        <img
          src="./assets/images/kofi.png"
          alt="Support me on Ko-fi"
          title="Support me on Ko-fi"
      /></a>
    </p>
  </nb-card-body>
  <nb-card-footer class="text-center">
    <button status="primary" nbButton (click)="close()">Got it</button>
  </nb-card-footer>
</nb-card>
